import DatePickerComponent from "ui/Date";
import {
	getBuyersFilterApi,
	getFishingGearApi,
	getPreservationsApi,
	getProductsApi,
	getSpecies,
} from "api/common";
import { FishingGear } from "interface/common";
import { Vessel } from "interface/vessel";
import { FC, useState } from "react";
import CustomButton from "ui/Button";
import CustomDropDownList from "ui/dropDown";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { VesselRenderItem } from "ui/dropdownItemList/VesselRenderItem";
import { SalesStatisticsFilter } from "api/sales";
import { getVesselFilter } from "api/vessel";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: SalesStatisticsFilter) => void;
	filterOptions: SalesStatisticsFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const [localFromDate, setLocalFromDate] = useState(filterOptions.fromDate);
	const [localToDate, setLocalToDate] = useState(filterOptions.toDate);

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.id,
			vesselName: vessel.id ? vessel.nm : "",
			vesselRegistrationNumber: vessel.id ? vessel.rn : "",
			take: props.pageSize,
			skip: 0,
		});
	};

	return (
		<div className="filter-container">
			<div className="filter-items sales-statistics-filter-items">
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={localFromDate}
						onChange={(e) => {
							setLocalFromDate(e.target.value);
						}}
						onBlur={() => {
							setFilterOptions({
								...filterOptions,
								fromDate: localFromDate,
								take: props.pageSize,
								skip: 0,
							});
						}}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={localToDate}
						onChange={(e) => {
							setLocalToDate(e.target.value);
						}}
						onBlur={() => {
							setFilterOptions({
								...filterOptions,
								toDate: localToDate,
								take: props.pageSize,
								skip: 0,
							});
						}}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						itemRender={VesselRenderItem()}
						value={{
							id: filterOptions.vesselId || null,
							/*nm: filterOptions.vesselName || t("ChooseVessel"),*/
							nm: filterOptions.vesselName || ' ',
						}}
						// label="Velg Fartøy"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						serverFilterApi={getVesselFilter}
						// popupSettings={{ width: 400 }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id,
								buyerName: buyer.name,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
							//	displayName: filterOptions.buyerName || t("ChooseBuyer"),
							displayName: filterOptions.buyerName || ' ',
						}}
						dataItemKey="id"
						textField="displayName"
						label={t("Buyer")}
						defaultItem={{ id: null, displayName: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
						popupSettings={{ width: 400 }}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						onSelect={(species) =>
							setFilterOptions({
								...filterOptions,
								speciesCode: species.code,
								species: species.name,
								take: props.pageSize,
								skip: 0,
							})
						}
						label={t("Species")}
						value={{
							code: filterOptions.speciesCode || null,
						//	name: filterOptions.species || t("ChooseSpecies"),
							name: filterOptions.species || ' ',
						}}
						dataItemKey="code"
						textField="name"
						defaultItem={{ code: null, name: t("All") }}
						filterable={true}
						serverFilter={true}
						serverFilterApi={getSpecies}
						className="height-inherit"
						popupSettings={{ width: 400 }}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(product) =>
							setFilterOptions({
								...filterOptions,
								productId: product.id,
								buyerName: product.name,
							})
						}
						data={[]}
						value={{
							id: filterOptions.productId || null,
						//	name: filterOptions.product || t("ChooseProduct"),
							name: filterOptions.product || ' ',
						}}
						dataItemKey="id"
						textField="name"
						label={t("Product")}
						defaultItem={{ id: null, name: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getProductsApi}
						popupSettings={{ width: 400 }}
					/>
				</div>
				<div style={{ width: "200px" }}>
					<CustomDropDownList
						data={[]}
						value={{
							code: filterOptions.fishingGearId || null,
							//	displayName: filterOptions.fishingGear || t("ChooseFishingGear"),
							displayName: filterOptions.fishingGear || ' ',
						}}
						className="height-inherit"
						dataItemKey="code"
						label={t("FishingGear")}
						textField="displayName"
						serverFilter={true}
						filterable={true}
						serverFilterApi={getFishingGearApi}
						defaultItem={{ value: null, displayName: t("All") }}
						onSelect={(gear: FishingGear) =>
							setFilterOptions({
								...filterOptions,
								fishingGearId: gear.id,
								fishingGear: gear.name,
								take: props.pageSize,
								skip: 0,
							})
						}
						popupSettings={{ width: 400 }}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(data) =>
							setFilterOptions({
								...filterOptions,
								preservationId: data.code,
								preservation: data.displayName,
							})
						}
						data={[]}
						value={{
							code: filterOptions.preservationId || null,
							//displayName: filterOptions.preservation || t("PreservationType"),
							displayName: filterOptions.preservation || ' ',
						}}
						dataItemKey="code"
						textField="displayName"
						label={t("PreservationType")}
						defaultItem={{ code: null, displayName: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getPreservationsApi}
						popupSettings={{ width: 300 }}
					/>
				</div>
			</div>

			<div className="filter-end-btn sales-statistics-filter-end-btn">
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
